// Generated by DesignToCode

import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card.html',
})
export class Card {
  // Inputs
  public title1 = input<string>('Quality & Code');
  public title2 = input<string>('Reviews');
  public description = input<string>(
    'Every solution goes through strict code review by senior engineers. UI changes also pass a Design team quality check. Quality is not optional.',
  );

  // Outputs
}
